module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.$route.path.indexOf('_detail') === -1) ? _c('div', [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "daterange",
      "value-format": "yyyy/MM/dd",
      "placeholder": "选择日期范围"
    },
    on: {
      "change": _vm.dateChange
    },
    model: {
      value: (_vm.create_time),
      callback: function($$v) {
        _vm.create_time = $$v
      },
      expression: "create_time"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "手机号/订单号"
    },
    model: {
      value: (_vm.identifier),
      callback: function($$v) {
        _vm.identifier = $$v
      },
      expression: "identifier"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.numberSearch
    },
    slot: "append"
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "md": 6,
      "lg": 4
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请选择订单类型"
    },
    on: {
      "change": _vm.TypeHandle
    },
    model: {
      value: (_vm.order_class),
      callback: function($$v) {
        _vm.order_class = $$v
      },
      expression: "order_class"
    }
  }, _vm._l((_vm.order_class_array), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.name,
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('el-autocomplete', {
    staticClass: "inline-input",
    attrs: {
      "fetch-suggestions": _vm.querySearch,
      "placeholder": "请输入来源"
    },
    on: {
      "select": _vm.sourceSearch
    },
    model: {
      value: (_vm.source_name),
      callback: function($$v) {
        _vm.source_name = $$v
      },
      expression: "source_name"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请选择店铺"
    },
    on: {
      "change": _vm.distributorSelectHandle
    },
    model: {
      value: (_vm.distributor_id),
      callback: function($$v) {
        _vm.distributor_id = $$v
      },
      expression: "distributor_id"
    }
  }, _vm._l((_vm.distributorList), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.name,
        "value": item.distributor_id
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-tabs', {
    attrs: {
      "type": "border-card"
    },
    on: {
      "tab-click": _vm.handleClick
    },
    model: {
      value: (_vm.activeName),
      callback: function($$v) {
        _vm.activeName = $$v
      },
      expression: "activeName"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "全部",
      "name": "all"
    }
  }), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "待发货",
      "name": "notship"
    }
  }), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "已完成",
      "name": "done"
    }
  }), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "未支付",
      "name": "notpay"
    }
  }), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "已取消",
      "name": "cancel"
    }
  }), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.list,
      "height": _vm.wheight - 190,
      "element-loading-text": "数据加载中"
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "order_id",
      "width": "150",
      "label": "订单号"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "create_time",
      "width": "160",
      "label": "创建时间"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(_vm._f("datetime")(scope.row.create_time, 'yyyy-MM-dd hh:mm:ss')))])]
      }
    }], null, false, 2176513052)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "distributor_name",
      "label": "所属店铺"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.distributor_name) ? _c('span', [_vm._v(_vm._s(scope.row.distributor_name))]) : _c('span', [_vm._v("总部")])]
      }
    }], null, false, 3711804642)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "70",
      "label": "运费"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n            " + _vm._s(scope.row.fee_symbol) + _vm._s(scope.row.freight_fee / 100) + "\n          ")]
      }
    }], null, false, 3107920480)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "total_fee",
      "width": "70",
      "label": "金额"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n            " + _vm._s(scope.row.fee_symbol) + _vm._s(scope.row.total_fee / 100) + "\n          ")]
      }
    }], null, false, 4222832577)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "110",
      "prop": "mobile",
      "label": "手机号"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "80",
      "label": "订单类型"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.order_class == 'normal') ? _c('span', [_vm._v("普通订单")]) : _vm._e(), _vm._v(" "), (scope.row.order_class == 'groups') ? _c('span', [_vm._v("团购订单")]) : _vm._e(), _vm._v(" "), (scope.row.order_class == 'seckill') ? _c('span', [_vm._v("秒杀订单")]) : _vm._e()]
      }
    }], null, false, 747126877)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "80",
      "prop": "order_status",
      "label": "订单状态"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.order_status == 'PAYED') ? _c('el-tag', {
          attrs: {
            "type": "success",
            "size": "mini"
          }
        }, [_vm._v("已支付")]) : (scope.row.order_status == 'NOTPAY') ? _c('el-tag', {
          attrs: {
            "size": "mini"
          }
        }, [_vm._v("未支付")]) : (scope.row.order_status == 'CANCEL') ? _c('el-tag', {
          attrs: {
            "type": "danger",
            "size": "mini"
          }
        }, [_vm._v("已取消")]) : (scope.row.order_status == 'WAIT_BUYER_CONFIRM') ? _c('el-tag', {
          attrs: {
            "type": "danger",
            "size": "mini"
          }
        }, [_vm._v("待收货")]) : _vm._e(), _vm._v(" "), (scope.row.order_status != 'CANCEL') ? [(scope.row.delivery_status == 'DONE') ? _c('el-tag', {
          attrs: {
            "type": "success",
            "size": "mini"
          }
        }, [_vm._v("已发货")]) : (scope.row.delivery_status == 'PARTAIL') ? _c('el-tag', {
          attrs: {
            "type": "danger",
            "size": "mini"
          }
        }, [_vm._v("部分发货")]) : (scope.row.ziti_status == 'PENDING') ? _c('el-tag', {
          attrs: {
            "type": "danger",
            "size": "mini"
          }
        }, [_vm._v("待自提")]) : (scope.row.ziti_status == 'DONE') ? _c('el-tag', {
          attrs: {
            "type": "danger",
            "size": "mini"
          }
        }, [_vm._v("已自提")]) : _c('el-tag', {
          attrs: {
            "size": "mini"
          }
        }, [_vm._v("待发货")])] : _vm._e()]
      }
    }], null, false, 298082877)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "source_name",
      "label": "来源"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "90",
      "label": "操作"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('router-link', {
          attrs: {
            "to": {
              path: _vm.matchHidePage('detail'),
              query: {
                orderId: scope.row.order_id,
                resource: '/mall/trade/normalorders'
              }
            }
          }
        }, [_vm._v("详情")]), _vm._v(" "), (scope.row.receipt_type == 'logistics' && scope.row.order_status == 'PAYED' && scope.row.delivery_status != 'DONE') ? _c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.deliveryAction(scope.row.order_id)
            }
          }
        }, [_vm._v("发货")]) : _vm._e()]
      }
    }], null, false, 3470193323)
  })], 1), _vm._v(" "), (_vm.total_count > _vm.params.pageSize) ? _c('div', {
    staticClass: "content-padded content-center"
  }, [_c('el-pagination', {
    attrs: {
      "layout": "prev, pager, next",
      "current-page": _vm.params.page,
      "total": _vm.total_count,
      "page-size": _vm.params.pageSize
    },
    on: {
      "current-change": _vm.handleCurrentChange,
      "update:currentPage": function($event) {
        return _vm.$set(_vm.params, "page", $event)
      },
      "update:current-page": function($event) {
        return _vm.$set(_vm.params, "page", $event)
      }
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.deliveryTitle,
      "visible": _vm.deliveryVisible,
      "before-close": _vm.handleCancel
    },
    on: {
      "update:visible": function($event) {
        _vm.deliveryVisible = $event
      }
    }
  }, [
    [_c('el-form', {
      ref: "deliveryForm",
      staticClass: "demo-ruleForm",
      attrs: {
        "model": _vm.deliveryForm,
        "label-width": "90px"
      }
    }, [_c('el-form-item', {
      attrs: {
        "label": "订单号"
      }
    }, [_c('el-col', {
      attrs: {
        "span": 20
      }
    }, [_vm._v(_vm._s(_vm.deliveryData.orderInfo.order_id))])], 1), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "商品信息"
      }
    }, [_c('el-col', {
      attrs: {
        "span": 30
      }
    }, [_c('el-table', {
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "data": _vm.deliveryData.orderInfo.items
      }
    }, [_c('el-table-column', {
      attrs: {
        "prop": "item_name",
        "label": "商品名",
        "width": "180"
      }
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "num",
        "label": "数量",
        "width": "180"
      }
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "label": "总价(元)"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [_c('span', [_vm._v("￥" + _vm._s(scope.row.total_fee / 100))])]
        }
      }], null, false, 3495371341)
    })], 1)], 1)], 1), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "快递公司"
      }
    }, [_c('el-col', [_c('el-select', {
      attrs: {
        "filterable": "",
        "placeholder": "请选择快递公司，可搜索"
      },
      model: {
        value: (_vm.deliveryForm.delivery_corp),
        callback: function($$v) {
          _vm.$set(_vm.deliveryForm, "delivery_corp", $$v)
        },
        expression: "deliveryForm.delivery_corp"
      }
    }, _vm._l((_vm.dlycorps), function(item) {
      return _c('el-option', {
        key: item.value,
        attrs: {
          "label": item.name,
          "value": item.value
        }
      })
    }), 1)], 1)], 1), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "快递单号"
      }
    }, [_c('el-col', {
      attrs: {
        "span": 14
      }
    }, [_c('el-input', {
      attrs: {
        "maxlength": 20,
        "placeholder": "物流公司单号"
      },
      model: {
        value: (_vm.deliveryForm.delivery_code),
        callback: function($$v) {
          _vm.$set(_vm.deliveryForm, "delivery_code", $$v)
        },
        expression: "deliveryForm.delivery_code"
      }
    })], 1)], 1)], 1)], _vm._v(" "), _c('div', {
      staticClass: "dialog-footer",
      attrs: {
        "slot": "footer"
      },
      slot: "footer"
    }, [_c('el-button', {
      nativeOn: {
        "click": function($event) {
          return _vm.handleCancel.apply(null, arguments)
        }
      }
    }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
      attrs: {
        "type": "primary"
      },
      on: {
        "click": _vm.submitDeliveryAction
      }
    }, [_vm._v("确定")])], 1)
  ], 2)], 1) : _vm._e(), _vm._v(" "), _c('router-view')], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-30d1848a", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-30d1848a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/mall/marketing/distributionOrders.vue
// module id = 2593
// module chunks = 0